import person from "../assets/imgs/person.png";
import person1 from "../assets/imgs/person1.png";

export const cardData = [
  {
    id: 1,
    name: "Name and Surname",
    title: `"This is an super space for your customers qoute. Don’t worry it works smooth as pie. You will get all what you need by writiing a text here `,
    img: `${person}`,
  },
  {
    id: 2,
    name: "Name and Surname",
    title: `"This is an super space for your customers qoute. Don’t worry it works smooth as pie. You will get all what you need by writiing a text here `,
    img: `${person1}`,
  },
  {
    id: 3,
    name: "Name and Surname",
    title: `"This is an super space for your customers qoute. Don’t worry it works smooth as pie. You will get all what you need by writiing a text here `,
    img: `${person}`,
  },
  {
    id: 4,
    name: "Name and Surname",
    title: `"This is an super space for your customers qoute. Don’t worry it works smooth as pie. You will get all what you need by writiing a text here `,
    img: `${person1}`,
  },
  {
    id: 5,
    name: "Name and Surname",
    title: `"This is an super space for your customers qoute. Don’t worry it works smooth as pie. You will get all what you need by writiing a text here `,
    img: `${person}`,
  },
  {
    id: 6,
    name: "Name and Surname",
    title: `"This is an super space for your customers qoute. Don’t worry it works smooth as pie. You will get all what you need by writiing a text here `,
    img: `${person1}`,
  },
  {
    id: 7,
    name: "Name and Surname",
    title: `"This is an super space for your customers qoute. Don’t worry it works smooth as pie. You will get all what you need by writiing a text here `,
    img: `${person}`,
  },
  {
    id: 8,
    name: "Name and Surname",
    title: `"This is an super space for your customers qoute. Don’t worry it works smooth as pie. You will get all what you need by writiing a text here `,
    img: `${person1}`,
  },
];
